import { useContext, useState } from 'react';
import { Button, PolimorphicGradientBackground } from '~/components';
import {
  BackgroundContainer, ComponentContainer, Container, CreditPowered, Footer, MainContentContainer, WelcomeText,
} from '../Authentication/styles';
import CelciusWhiteLogo from '~/assets/img/logos/CelciusWhiteLogo.svg';
import LogoDielPowered from '~/assets/img/logos/LogoDielPowered.svg';
import DielDarkLogo from '~/assets/img/logos/DielDarkLogo.svg';
import { t } from 'i18next';
import { MainContent } from '../Authentication/Login/styles';
import { useHistory } from 'react-router-dom';
import SelectPlataformContext from '../../contexts/selectPlataform';
import { colors } from '~/styles/colors';
import { MouseIcon, NewBoxIcon } from '~/icons';
import { ButtonComponent } from './styles';

export default function LoginSelectPage() {
  const history = useHistory();
  const { setSelectPlataform } = useContext(SelectPlataformContext);
  function select(path: string) {
    localStorage.setItem('choosePlataform', path);
    setSelectPlataform(path);
    history.push(path);
  }

  return (
    <PolimorphicGradientBackground data-testid="controle_inteligente-tag-alterar_visualizacao-ambas-visualizacoes">
      <Container>
        <BackgroundContainer>
          <WelcomeText>
            <p className="welcome">{t('bemVindoAo')}</p>
            <img src={CelciusWhiteLogo} alt="celcius white logo" />
          </WelcomeText>
          <CreditPowered>
            <span>Powered by</span>
            <img src={LogoDielPowered} alt="diel white logo" />
          </CreditPowered>
        </BackgroundContainer>
        <MainContentContainer>
          <ComponentContainer isLoading={false}>
            <img src={DielDarkLogo} alt="diel dark logo" />
            <MainContent>
              <p style={{ fontSize: 15, color: colors.text['soft-400'], fontWeight: 700 }}>{t('escolhaProdutoAcessar')}</p>
              <Button data-testid="controle_inteligente-tag-alterar_visualizacao_para_controle_inteligente-visualizacao_celsius" type="button" variant="primary" style={{ textTransform: 'unset', padding: 9, borderRadius: 5 }} onClick={() => { select('/analise/unidades'); }}>
                <ButtonComponent>
                  <NewBoxIcon color="#fff" />
                  <span>{t('entrarCelsius')}</span>
                </ButtonComponent>
              </Button>
              <Button data-testid="controle_inteligente-tag-alterar_visualizacao_para_celsius-visualizacao_controle_inteligente" type="button" variant="blue-white" style={{ textTransform: 'unset', padding: 9, borderRadius: 5 }} onClick={() => { select('/controle-inteligente'); }}>
                <ButtonComponent>
                  <MouseIcon />
                  <span>{t('controleInteligente')}</span>
                </ButtonComponent>
              </Button>
              <span
                style={{
                  textAlign: 'center', color: colors.text['soft-400'], fontWeight: 600, cursor: 'pointer', marginTop: 8, fontSize: 11,
                }}
                onClick={() => { localStorage.clear(); history.push('login'); }}
              >
                {t('voltarLogin')}
              </span>
            </MainContent>
            <Footer>
              <p>
                {`© ${new Date().getFullYear()}`}
                <>&nbsp;</>
                <strong>{t('tituloPagDielEnergia')}</strong>
                <>&nbsp;</>
                {t('todosDireitos')}
              </p>
            </Footer>
          </ComponentContainer>
        </MainContentContainer>
      </Container>
    </PolimorphicGradientBackground>
  );
}
